module.exports = __webpack_public_path__ + "img/learning-disability-friendly.c4beb007.png";